<template>
    <div
        class="l-ss-c-results-empty-section"
        :class="{ 'l-ss-c-results-empty-section-with-offers': popularOffers.length }">
        <section-results-info
            :search="search"
            :show-autocomplete-elements="false"
            @autocomplete-search="emitAutocompleteSearch"/>
        <ul
            class="l-ss-c-results-empty-section-tags"
            v-if="popularQueries.length">
            <li
                v-for="(tag, index) in popularQueries"
                :key="`popular-query-tag-${index}`"
                class="l-ss-c-results-empty-section-tag"
                @click="onTagClick(tag.text.value)">
                {{ tag.text.value }}
            </li>
        </ul>

        <div
            class="l-ss-c-results-empty-offers-wrapper"
            :class="{ 'l-ss-c-results-empty-offers-wrapper-mobile': $screen.isMobile }"
            v-if="popularOffers.length">
            <div class="l-ss-c-results-empty-offers-title">{{ $t('results.popularOffers') }}</div>
            <offers-wrapper
                :view="view"
                :key="offerLayout"
                :offer-layout="offerLayout"
                :breakpoint="currentBreakpoint"
                :offers="popularOffers"
                v-on="offersWrapperEventListeners"/>
        </div>
    </div>
</template>

<script>
    import SectionResultsInfo from '@/core/components/section-results/section-results-info.vue';
    import OffersWrapper from '@/core/components/offers-wrapper.vue';
    import EventEmitterMixin from '@/core/mixins/event-emitter';
    import { commonOfferEventHandlers, mapHandlers } from '@/core/mixins/event-emitter';

    import getCurrentBreakpoint from '@/core/helpers/get-current-breakpoint';

    export default {
        components: { OffersWrapper, SectionResultsInfo },
        mixins: [EventEmitterMixin],
        inject: ['store'],
        props: {
            search: {
                type: Object,
            },
            popularQueries: {
                type: Array,
                default: () => [],
            },
            popularOffers: {
                type: Array,
            },
            isCompletions: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                breakpoints: null,
                currentBreakpoint: {
                    columnCount: 2,
                    gridGap: 24,
                },
            };
        },
        computed: {
            offerLayout() {
                const placesForLayout = this.$configuration.placesForOfferLayout;
                const isMobile = this.$screen.isMobile;

                let layout = '';

                if (!isMobile) {
                    if (this.currentBreakpoint.offerLayout) {
                        return this.currentBreakpoint.offerLayout;
                    }

                    layout = this.isCompletions ?
                        placesForLayout.completionsNoResults :
                        placesForLayout.noResults;
                } else {
                    layout = this.isCompletions ?
                        placesForLayout.mobileCompletionsNoResults :
                        placesForLayout.mobileNoResults;
                }

                return layout;
            },
            view() {
                return this.currentBreakpoint.columnCount > 1 || this.$screen.isMobile ? 'grid' : 'row';
            },
            offersWrapperEventListeners() {
                return {
                    ...mapHandlers(this, commonOfferEventHandlers),
                };
            },
        },
        created() {
            if (!this.isCompletions) {
                this.breakpoints = this.$configuration.layout.emptyResultsBreakpoints;
            } else {
                this.breakpoints = this.$configuration.layout.completionsEmptyResultsBreakpoints;
            }

            if (this.breakpoints) {
                this.setCurrentBreakpoint();
                window.addEventListener('resize', this.setCurrentBreakpoint);
            }
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.setCurrentBreakpoint);
        },
        methods: {
            setCurrentBreakpoint() {
                const breakpoint = getCurrentBreakpoint(this.breakpoints, window.innerWidth);
                if (breakpoint) {
                    this.currentBreakpoint = breakpoint;
                }
            },
            onTagClick(value) {
                this.emitHandleTagsClick(value);
            },
        },
    };
</script>
